export type DragZone = 'left-edge' | 'right-edge' | 'body';

/** Edge hit-box width in px — controls resize grab area. */
export const EDGE_HITBOX_PX = 8;

/**
 * Decides which drag intent a pointerdown at {@link localX} (bar-relative)
 * inside a bar of {@link barWidth} px starts:
 *
 * - `'left-edge'`  → resize-start
 * - `'right-edge'` → resize-end
 * - `'body'`       → move
 *
 * If the bar is narrower than twice the edge hit-box, both edges would
 * overlap, so the whole bar is treated as body to keep a move target.
 */
export function detectDragZone(localX: number, barWidth: number): DragZone {
  if (barWidth <= EDGE_HITBOX_PX * 2) return 'body';
  if (localX < EDGE_HITBOX_PX) return 'left-edge';
  if (localX > barWidth - EDGE_HITBOX_PX) return 'right-edge';
  return 'body';
}
